<template>
  <div class="container mt-5">
    <button class="btn btn-outline-secondary mb-4" @click="goBack">
      <font-awesome-icon icon="arrow-left" class="me-2" />
      {{ $t("common.back") }}
    </button>

    <div class="text-center mb-5">
      <h1>{{ $t("signup.corporate.title") }}</h1>
      <p class="lead text-muted">{{ $t("signup.corporate.description") }}</p>
    </div>

    <CorporateCompanyForm
      :company="companyData"
      :loading="loading"
      :is-admin="isAdmin"
      @submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { useCorporateSignup } from "@/signup/composables/useCorporateSignup";
import CorporateCompanyForm from "@/signup/corporate/CorporateCompanyForm.vue";
import { signupApi } from "@/signup/signupApi";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useGlobalHandlers } from "@/composables/useGlobalHandlers";

const router = useRouter();
const { globalErrorHandler } = useGlobalHandlers();
const { companyData, loading, isAdmin, createCompany } = useCorporateSignup();

const goBack = () => {
  router.push("/signup");
};

const handleSubmit = async (data: any) => {
  try {
    const result = await createCompany(data);
    router.push(`/dashboard?company_id=${result.company_id}`);
  } catch {
    // createCompany already reports the error (with a specific message for the
    // company-creation rate limit); re-reporting here would overwrite it.
  }
};

onMounted(() => {
  signupApi
    .setOnboardingStep("CORPORATE")
    .catch((error) => globalErrorHandler(error));
});
</script>
